module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('login.title')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('v-alert', {
    staticClass: "mb-3",
    attrs: {
      "error": "",
      "value": !!_vm.error,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.languages
    },
    model: {
      value: (_vm.language),
      callback: function($$v) {
        _vm.language = $$v
      },
      expression: "language"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('login.username'),
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "password",
      "label": _vm.$t('login.password'),
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "type": "submit",
      "flat": "",
      "loading": _vm.isBusy
    }
  }, [_vm._v(_vm._s(_vm.$t('login.login')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/forgotten-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.forgotten')))])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "media"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo2.jpg")
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c3135f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 1050
// module chunks = 1